import React from "react";

function View(props) {
  return <div>Not Found 404</div>;
}

export default View;
